import { computed, ref } from 'vue';
import client from '@/client/index';
export function useFetchResources(target, query) {
    if (query === void 0) { query = {}; }
    var results = ref(new Array);
    var params = ref(query);
    var fetching = ref(false);
    var empty = computed(function () { return results.value.length == 0; });
    var success = ref(false);
    var failure = ref(false);
    var meta = ref(new Object());
    var succeed = function (result) {
        var _a;
        results.value = result.data;
        meta.value = (_a = result.meta) !== null && _a !== void 0 ? _a : {};
        fetching.value = false;
        success.value = true;
        failure.value = false;
    };
    var fail = function (error) {
        results.value = new Array;
        fetching.value = false;
        meta.value = {};
        success.value = false;
        failure.value = true;
    };
    var fetch = function () {
        fetching.value = true;
        client.get(target.value, { params: params.value })
            .then(function (result) { return succeed(result.data); })
            .catch(function (error) { return fail(error); });
    };
    return { fetch: fetch, results: results, meta: meta, fetching: fetching, empty: empty, success: success, failure: failure };
}
;
